import { createFileRoute } from '@tanstack/react-router';

import { SyncRelationSweepRunsPage } from '@pages/sync';

/**
 * Sync - Relation Sweep Runs
 *
 * Route: /:locale/sync/sweep-runs
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/sweep-runs')({
  component: SyncRelationSweepRunsRoute,
});

function SyncRelationSweepRunsRoute() {
  return <SyncRelationSweepRunsPage />;
}
